var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import omit from "lodash/omit";
import { client } from "../client";
export var getTracksByIds = function (tracksIds) {
    return client
        .get("/api/v1/tracks/".concat(tracksIds.join(",")))
        .then(function (response) {
        var e_1, _a;
        var tracks = [];
        var _loop_1 = function (id) {
            var track = response.data.tracks.find(function (track) { return track.id === id; });
            if (!track)
                return "continue";
            tracks.push(__assign(__assign({}, omit(track, ["is_private", "user_id", "md5", "size"])), { isPrivate: track.is_private, userId: track.user_id }));
        };
        try {
            for (var tracksIds_1 = __values(tracksIds), tracksIds_1_1 = tracksIds_1.next(); !tracksIds_1_1.done; tracksIds_1_1 = tracksIds_1.next()) {
                var id = tracksIds_1_1.value;
                _loop_1(id);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (tracksIds_1_1 && !tracksIds_1_1.done && (_a = tracksIds_1.return)) _a.call(tracksIds_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return tracks;
    });
};
export var getRawTracksByIds = function (tracksIds) {
    return client
        .get("/api/v2/tracks/".concat(tracksIds.join(",")))
        .then(function (response) {
        var tracks = [];
        var track = response.data.data;
        tracks.push(track);
        return tracks;
    });
};
